import { render, staticRenderFns } from "./GroupSchedule.vue?vue&type=template&id=7016080c&"
import script from "./GroupSchedule.vue?vue&type=script&lang=js&"
export * from "./GroupSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports